<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>제휴기관 등록</strong></div>
			<h2 class="h_sub">제휴기관 등록</h2>
		</div>

    <PartnerManageCreateForm/>
  </div>
</template>

<script>
import PartnerManageCreateForm from '@/components/admin/etc/PartnerManageCreateForm.vue';

export default {
  components: {
    PartnerManageCreateForm
  }
}
</script>
<style lang="">
    
</style>